import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';

export default function PurchaseHistory() {
  return (
    <DashboardLayout>
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Purchase History</h1>
        <p>Your purchase history will be displayed here.</p>
        {/* You can add the actual purchase history logic and components here */}
      </div>
    </DashboardLayout>
  );
} 